import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store';
import { ApiError } from '../services/api';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { login } = useAuthStore();
  const nav = useNavigate();
  const [params] = useSearchParams();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
      const next = params.get('next');
      nav(next && next.startsWith('/') ? next : '/');
    } catch (e) {
      if (e instanceof ApiError) {
        if (e.status === 401) setError('Invalid email or password');
        else if (e.code === 'invalid_email_domain') setError('Email must be @3dtsi.com');
        else if (e.status === 429) setError('Too many attempts. Wait a minute and try again.');
        else setError(e.message || 'Login failed');
      } else setError('Login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-md border border-slate-200 p-8">
        <h1 className="text-2xl font-bold text-brand-navy">Ultimate Bidder <span className="text-brand-gold">v2</span></h1>
        <p className="text-slate-500 text-sm mt-1 mb-6">3DTSI internal · @3dtsi.com accounts only</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
            <input
              type="email" required autoFocus value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-slate-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-navy/40"
              placeholder="you@3dtsi.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
            <input
              type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-slate-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-navy/40"
            />
          </div>
          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>
          )}
          <button
            type="submit" disabled={busy}
            className="w-full bg-brand-navy text-white font-semibold rounded-md py-2 hover:bg-brand-navy/90 disabled:opacity-50"
          >
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div className="mt-4 text-center text-sm">
          <Link to="/forgot-password" className="text-brand-navy hover:underline">
            Forgot password?
          </Link>
        </div>
      </div>
    </main>
  );
}
